import React from "react";
import { useDispatch } from "react-redux";
import {
  useForm,
  SubmitHandler,
} from "react-hook-form";
import { InputTextField } from "../FormFields/RenderInputTextField";
import { SelectField } from "../FormFields/RenderSelectField";
import { DateTimeField } from "../FormFields/RenderDateTimeField";
import { createVoyage, updateVoyage } from "../../data/voyage";
import { hideModal } from "../../data/modal";
import { Voyage, TerminalCall } from "../../types";
import { useRefreshVoyageData } from "../hooks/useRefreshVoyageData";

import {
  Button,
  Grid,
} from "@mui/material";
import {
  Close as CloseIcon,
  Save as SaveIcon,
} from "@mui/icons-material";

interface Props {
  voyage?: Voyage;
}

const STATUS_OPTIONS = [
  { value: "active", label: "Active" },
  { value: "archived", label: "Archived" },
];

export default function VoyageForm({ voyage }: Props) {
  const dispatch = useDispatch();

  const { control, handleSubmit, formState } = useForm<
    Partial<Voyage> & { terminalCalls: TerminalCall[] }
  >({
    defaultValues: voyage ?? {
      status: "active",
    } as any,
  });
  const { isSubmitting } = formState;

  const refreshVoyageData = useRefreshVoyageData();

  const onSubmit: SubmitHandler<any> = (data) => {
    if (voyage) {
      dispatch(updateVoyage(data));
    } else {
      dispatch(createVoyage(data));
    }

    dispatch(hideModal());
    refreshVoyageData(data);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
         <Grid container spacing={2} padding={2}>
        <Grid container xs={8}>
            <Grid item xs={8} mt={2}>
                <InputTextField
                    name="name"
                    label="Voyage Name"
                    control={control}
                    required
                />
            </Grid>

            <Grid item xs={8} className="form-field-datetime" mt={2}>
                <DateTimeField
                    name="startDate"
                    label="Start Date"
                    control={control}
                    required
                />
            </Grid>

            <Grid item xs={8} className="form-field-datetime" mt={2}>
                <DateTimeField
                    name="endDate"
                    label="End Date"
                    control={control}
                    required
                />
            </Grid>
        </Grid>
            <Grid container xs={4}>
            <Grid item xs={12} mt={2}>
                <SelectField
                    name="status"
                    label="Status"
                    control={control}
                    options={STATUS_OPTIONS}
                    required
                />
            </Grid>
        </Grid>
        <Grid item xs={12} className="button-wrapper">
            <Button
                variant="outlined"
                startIcon={<CloseIcon />}
                onClick={() => dispatch(hideModal())}
                disabled={isSubmitting}
            >
                Close
            </Button>
            <Button
                type="submit"
                variant="contained"
                startIcon={<SaveIcon />}
                disabled={isSubmitting}
            >
                Save
            </Button>
        </Grid>
      </Grid>
    </form>
  );
}